import "/code/src/main.css?transform-only";export default "__VITE_CSS_URL__2f636f64652f7372632f6d61696e2e6373733f7472616e73666f726d2d6f6e6c79__"